import {
    emptyValidator,
    formValidator,
    numberReangeValidator,
    mobilePhoneMenValidator,
    emailMenValidator,
    mobilePhoneNotMenValidator,
} from "../../validators";

// New

const requestInitiationValidation = {
    reqLCustomerId: {
        validators: [emptyValidator()],
        name: "Customer",
    },
    reqLPlantId: {
        validators: [emptyValidator()],
        name: "Plant Name",
    },
    reqContactPerson: {
        validators: [emptyValidator()],
        name: "Contact person",
    },
    reqContactNumber: {
        validators: [emptyValidator(), mobilePhoneMenValidator()],
        name: "Contact Number",
    },
    reqShipmentType: {
        validators: [emptyValidator()],
        name: "Shipment Type",
    },
    reqConsolidateAllowed: {
        validators: [emptyValidator()],
        name: "Consolidate Type",
    },
};

export const dynamicRequestInitiationValidation = {
    reqBehalfOf: {
        validators: [emptyValidator()],
        name: "Behalf of",
    },
    reqOperationType: {
        validators: [emptyValidator()],
        name: "Operation Type",
    },
    reqExportImport: {
        validators: [emptyValidator()],
        name: "Shipment Category",
    },
    reqLCustomerId: {
        validators: [emptyValidator()],
        name: "Customer",
    },
    reqContactEmail: {
        validators: [emptyValidator()],
        name: "Email",
    },
    reqPono: {
        validators: [emptyValidator()],
        name: "P.O No",
    },
    reqBlno: {
        validators: [emptyValidator()],
        name: "B/L No",
    },
    reqBookingRequiredDate: {
        validators: [emptyValidator()],
        name: "Booking Required Date",
    },
    reqDeliveryCutoff: {
        validators: [emptyValidator()],
        name: "Cut off Time",
    },
    reqPackages: {
        validators: [emptyValidator()],
        name: "Packages",
    },
    reqReferanceValue: {
        validators: [emptyValidator()],
        name: "Reference Number",
    },
    reqInvoiceRef: {
        validators: [emptyValidator()],
        name: "Invoice Ref No",
    },
    reqDepartment: {
        validators: [emptyValidator()],
        name: "Department",
    },
    reqVessel: {
        validators: [emptyValidator()],
        name: "Vessel Number",
    },
    reqVayage: {
        validators: [emptyValidator()],
        name: "Voyage Number",
    },
    reqLPlantId: {
        validators: [emptyValidator()],
        name: "Plant Name",
    },
    reqContactPerson: {
        validators: [emptyValidator()],
        name: "Contact person",
    },
    reqContactNumber: {
        validators: [emptyValidator(), mobilePhoneMenValidator()],
        name: "Contact Number",
    },
    reqShipmentType: {
        validators: [emptyValidator()],
        name: "Shipment Type",
    },
    reqConsolidateAllowed: {
        validators: [emptyValidator()],
        name: "Consolidate Type",
    },
    reqType: {
        validators: [emptyValidator()],
        name: "Request Commitment Type",
    },
};

export const transporterCreationValidation = {
    reqItemTypes: {
        validators: [emptyValidator()],
        name: "Item Type",
    },
    reqManageItems: {
        validators: [emptyValidator()],
        name: "Manage Items",
    },
    reqMultiConsignee: {
        validators: [emptyValidator()],
        name: "Multi Consignee",
    },
    reqVehicleTypeId: {
        validators: [emptyValidator()],
        name: "Vehicle Type",
    },
    vehicleMaxCbm: {
        validators: [emptyValidator()],
        name: "Max CBM",
    },
    rcoConsignee: {
        validators: [emptyValidator()],
        name: "Consignees",
    },
    rcoCbm: {
        validators: [emptyValidator()],
        name: "CBM",
    },
    rcoQty: {
        validators: [emptyValidator()],
        name: "Qty",
    },
    reqContainerno: {
        validators: [emptyValidator()],
        name: "Container No",
    },
    reqContainerType: {
        validators: [emptyValidator()],
        name: "Container Type",
    },
    multiConsignmentType: {
        validators: [emptyValidator()],
        name: "Multiple Consignment",
    },
    reqConsignmentType: {
        validators: [emptyValidator()],
        name: "Consignment Types",
    },
    reqNumberOfTrailers: {
        validators: [emptyValidator()],
        name: "Number of Trailers",
    },
    reqNumberOfVehicles: {
        validators: [emptyValidator()],
        name: "Number of Vehicles",
    },
    reqGrossWeight: {
        validators: [emptyValidator()],
        name: "Gross Weight",
    },
    reqTotalValye: {
        validators: [emptyValidator()],
        name: "Gross Value",
    },
    reqKAGNo: {
        validators: [emptyValidator()],
        name: "KAG Number",
    },
};

// {
//       rmjRequest: null,
//       rmjJob: null,
//       rmjCompany: null,
//       rmjReferance: null,
//       rmjDescription: "",
//       rmjVehicleType: null,
//       rmjVehicleQty: 1,
//       rmjMaxCbm: "",
//       rmjConsignees: null,
//       rmjConsigneeName: "",
//       rmjConsigneeCbm: "",
//       rmjContainerType: null,
//       rmjContianerNumber: "",
//       rmjCompleted: 1,
//       rmjStatus: 2,
//       rmjActive: 1,
//       vehicleTypeValue: "",
//       containerTypeValue: "",
//       completedValue : ""
//     }

export const requestMultipleJobValidation = {
    rmjVehicleType: {
        validators: [emptyValidator()],
        name: "Vehicle Type",
    },
    rmjVehicleQty: {
        validators: [emptyValidator()],
        name: "Qty",
    },
    rmjMaxCmb: {
        validators: [emptyValidator()],
        name: "Max CBM",
    },
    rmjContainerType: {
        validators: [emptyValidator()],
        name: "Container Type",
    },
    rmjContianerNumber: {
        validators: [emptyValidator()],
        name: "Container Number",
    },
    rmjConsignees: {
        validators: [emptyValidator()],
        name: "Consignee",
    },
    rmjConsigneeCbm: {
        validators: [emptyValidator()],
        name: "Consignee CBM",
    },
    rmjCompleted: {
        validators: [emptyValidator()],
        name: "Completed",
    },
}

export const validateRequestMultipleJob = (data, validationMap) => {
    return formValidator(data, validationMap);
};

export const otherValidationState = {
    rotChargeType: {
        validators: [emptyValidator()],
        name: "Charge Type",
    },
    // rotValue: {
    //   validators: [emptyValidator(), numberReangeValidator(0)],
    //   name: "Value",
    // },
    rotStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
    rotValue: {
        validators: [emptyValidator()],
        name: "Value",
    },
    rotRemarks: {
        validators: [emptyValidator()],
        name: "Remark",
    },
};

const singleConsigneetransporterCreationValidation = {
    reqItemTypes: {
        validators: [emptyValidator()],
        name: "Item Type",
    },
    reqManageItems: {
        validators: [emptyValidator()],
        name: "Manage Items",
    },
    reqMultiConsignee: {
        validators: [emptyValidator()],
        name: "Multi Consignee",
    },
    reqVehicleTypeId: {
        validators: [emptyValidator()],
        name: "Vehicle Type",
    },
    rcoCbm: {
        validators: [emptyValidator()],
        name: "CBM",
    },
};

export const validateRequestInitiation = (data, validationMap) => {
    return formValidator(data, validationMap);
};

export const validateRequestTransport = (data, validationMap) => {
    return formValidator(data, validationMap);
};

// export const validateSingleConsigneeRequestTransport = (data) => {
//   return formValidator(data, singleConsigneetransporterCreationValidation);
// };

export const validateOther = (data, validationMap) => {
    return formValidator(data, validationMap);
};

const locationValidationRules = {
    // locationType: {
    //     validators: [emptyValidator()],
    //     name: "Location Type",
    // },
    flagType: {
        validators: [emptyValidator()],
        name: "Flag Type",
    },
    rlkArrivalEta: {
        validators: [emptyValidator()], // Consider adding a dateValidator if needed
        name: "Arrival Time",
    },
    departureTime: {
        validators: [emptyValidator()], // Consider adding a dateValidator if needed
        name: "Departure Time",
    },
    rlkContactPerson: {
        validators: [emptyValidator()],
        name: "Contact Person",
    },

    // Add more location-related fields as needed
};

export const locationValidation = {
    rlkLocation: {
        validators: [emptyValidator()],
        name: "Location",
    },
    rlkArrivalEta: {
        validators: [emptyValidator()],
        name: "Arrival Time",
    },
    rlkDepartureEta: {
        validators: [emptyValidator()],
        name: "Departure Time",
    },
    rlkContactPersonId: {
        validators: [emptyValidator()],
        name: "Contact Person",
    },
    rlkLocationContactName: {
        validators: [emptyValidator()],
        name: "Location Contact Name",
    },
    rlkLocationContactNumber: {
        changeWhenMandatory: true,
        mandatoryValidators: [mobilePhoneMenValidator()],
        nonMandatoryValidators: [mobilePhoneNotMenValidator()],
        name: "Location Contact Number",
    },
    rlkPickDrop: {
        validators: [emptyValidator()],
        name: "Pick Drop Type",
    }
};

export const reqPhoneValidator = (data) => {
    return formValidator(data, locationValidation);
};

export const summaryInfoValidation = {
    reqCbm: {
        validators: [emptyValidator()],
        name: "CBM",
    },
    reqQty: {
        validators: [emptyValidator()],
        name: "QTY",
    },
    reqUom: {
        validators: [emptyValidator()],
        name: "UOM",
    },
    reqTotalKm: {
        validators: [emptyValidator()],
        name: "Total KM",
    },
    reqRemarks: {
        validators: [emptyValidator()],
        name: "Remarks",
    },
    reqStatus: {
        validators: [emptyValidator()],
        name: "Status",
    },
};

export const validateSummaryInfo = (data, validationMap) => {
    return formValidator(data, validationMap);
};
export const validateRequestLocation = (location, validationMap) => {
    return formValidator(location, validationMap);
};

export const consigneeValidationRules = {
    rcoLocation: {
        validators: [emptyValidator()],
        name: "Location",
    },
    rcoConsignee: {
        validators: [emptyValidator()],
        name: "Consignee",
    },
    rcoConsignmentType: {
        validators: [emptyValidator()],
        name: "Consignement Type",
    },
    rcoCbm: {
        validators: [emptyValidator()],
        name: "CBM",
    },
    rcoQty: {
        validators: [emptyValidator()],
        name: "QTY",
    },
};

export const validateRequestConsignee = (consignee, validationMap) => {
    return formValidator(consignee, validationMap);
};
